import React, { useState } from 'react';
import { User } from '../types/user';

interface UserFormProps {
  onSubmit: (userData: Partial<User> & { password?: string }) => void;
  onCancel: () => void;
  initialData?: User;
}

const UserForm: React.FC<UserFormProps> = ({ onSubmit, onCancel, initialData }) => {
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);

    const formData = new FormData(e.currentTarget);
    const userData: Partial<User> & { password?: string } = {
      username: formData.get('username') as string,
      role: formData.get('role') as 'admin' | 'user',
      isAdmin: formData.get('role') === 'admin'
    };

    if (!initialData) {
      userData.password = formData.get('password') as string;
    }

    if (!userData.username || (!initialData && !userData.password)) {
      setError('Lütfen tüm alanları doldurun');
      return;
    }

    onSubmit(userData);
  };

  return (
    <form onSubmit={handleSubmit} className="user-form">
      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <div className="mb-3">
        <label htmlFor="username" className="form-label">
          Kullanıcı Adı
        </label>
        <input
          type="text"
          className="form-control"
          id="username"
          name="username"
          defaultValue={initialData?.username}
          required
        />
      </div>

      {!initialData && (
        <div className="mb-3">
          <label htmlFor="password" className="form-label">
            Şifre
          </label>
          <input
            type="password"
            className="form-control"
            id="password"
            name="password"
            required={!initialData}
          />
        </div>
      )}

      <div className="mb-3">
        <label htmlFor="role" className="form-label">
          Rol
        </label>
        <select
          className="form-select"
          id="role"
          name="role"
          defaultValue={initialData?.role || 'user'}
        >
          <option value="user">Kullanıcı</option>
          <option value="admin">Yönetici</option>
        </select>
      </div>

      <div className="d-flex gap-2">
        <button type="submit" className="btn btn-primary">
          {initialData ? 'Güncelle' : 'Oluştur'}
        </button>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          İptal
        </button>
      </div>
    </form>
  );
};

export default UserForm; 